/**
 * Emoji – dieselben Zeichen wie in WhatsApp, gezeichnet vom Gerät.
 *
 * Unicode ist ein Standard; die Bilder liefert die Schrift des Rechners
 * (unter Windows „Segoe UI Emoji"). Die Grafiken von WhatsApp selbst sind
 * geschützt und werden nicht mitgeliefert – nötig ist das auch nicht, das
 * Zeichen ist dasselbe und kommt beim Empfänger richtig an.
 *
 * Die Gruppe „Arbeit" ist auf den Betrieb zugeschnitten: Was bei Eichenherz
 * vorkommt, soll man finden, ohne durch achthundert Zeichen zu blättern.
 */

const GESICHTER =
  '😀 😃 😄 😁 😅 😂 🙂 😊 😉 😌 😍 😘 😎 🤓 🧐 🤔 🤨 😐 😶 🙄 😏 😬 😮 😯 😲 😳 🥺 😢 😭 😤 😠 😡 🤯 😴 🤝 🙏'.split(' ');
const HAENDE = '👍 👎 👌 ✌️ 🤞 👏 🙌 💪 🤙 👋 ✋ 🖐️ ☝️ 👆 👇 👉 👈 🤲 🫶 ✍️ 🤘 🫱 🫲 🖖 🤟 👊 ✊ 🤛 🤜 🫰 🫵 🤌 👐 🙇 💁 🤷'.split(' ');
const SYMBOLE = '✅ ❌ ⚠️ ❗ ❓ ⭐ 🔥 💡 🎯 ⏰ ⏳ 📌 📎 🔗 ➕ ➖ ✔️ ✖️ 🔴 🟠 🟡 🟢 🔵 ⚫ ⚪ 🔒 🔓 ♻️ 🆗 🆕 💯 🎉 👀 🤞 ℹ️ 🔔'.split(' ');
/** Was bei Eichenherz täglich vorkommt – Vorgang, Ware, Termin, Werkstatt. */
const ARBEIT = '📅 📆 📞 ☎️ 📧 🚚 📦 🪟 🚪 🔑 🧾 🧰 🔧 🔨 🪛 📐 📏 🏠 🏢 🏗️ 🧱 🪜 ⚡ 💶 🧮 📊 📈 📉 🗂️ 📁 📂 🖨️ ✏️ 📝 🗒️ 🚗'.split(' ');

export const EMOJI_GRUPPEN: { name: string; zeichen: string[] }[] = [
  { name: 'Arbeit', zeichen: ARBEIT },
  { name: 'Gesichter', zeichen: GESICHTER },
  { name: 'Hände', zeichen: HAENDE },
  { name: 'Symbole', zeichen: SYMBOLE },
];

/*
 * Ein Emoji erkennen.
 *
 * Gesucht wird nach den Unicode-Eigenschaften „Extended_Pictographic" samt
 * Modifikatoren und Verbindern (Hautton, Variantenwähler, ZWJ). Eine Liste
 * von Zeichen wäre nach dem nächsten Unicode-Jahrgang unvollständig.
 */
const EMOJI = /(\p{Extended_Pictographic}(️|\p{Emoji_Modifier})?(‍\p{Extended_Pictographic}(️)?)*|[\u{1F1E6}-\u{1F1FF}]{2})/gu;

/**
 * Text in Emoji- und Nicht-Emoji-Abschnitte zerlegen.
 *
 * Damit kann die Anzeige die Zeichen größer setzen: Auf 13,5 px Fließtext
 * verschwindet ein Emoji fast; auf 17 px ist es lesbar, ohne die Zeile zu
 * sprengen.
 */
export function emojiZerlegen(text: string): { t: string; emoji: boolean }[] {
  const stuecke: { t: string; emoji: boolean }[] = [];
  let zuletzt = 0;
  for (const treffer of text.matchAll(EMOJI)) {
    const i = treffer.index ?? 0;
    if (i > zuletzt) stuecke.push({ t: text.slice(zuletzt, i), emoji: false });
    stuecke.push({ t: treffer[0], emoji: true });
    zuletzt = i + treffer[0].length;
  }
  if (zuletzt < text.length) stuecke.push({ t: text.slice(zuletzt), emoji: false });
  return stuecke.length ? stuecke : [{ t: text, emoji: false }];
}
